toastr.options = {
    "closeButton": true,
    "debug": false,
    "newestOnTop": false,
    "progressBar": true,
    "positionClass": "toast-top-right",
    "preventDuplicates": false,
    "onclick": null,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
}
jQuery(document).ready(function ($) {
    var msg = $('#msg').html();
    if (msg != undefined) {
        toastr.error(msg);
    }
    $('input[type="password"]').hidePassword('focus', {
        toggle: {className: 'my-toggle'}
    });
    $('button#remove-img').click(function (e) {
        e.preventDefault();
        $(this).parents('.col-md-2').remove();
        $('<div class="col-md-9"><input class="class" form-control="form-control" name="image" type="file" id="image"></div>').insertAfter('label[for=image]');
    });
});
